import Big from 'big.js';
import config from 'utils/solaris/config';
import { formatMoney } from 'utils/numberSplit';
import { fixDecimalString } from 'utils/numberUtils';

const calculateYearlyDiscount = (amount) =>
  Big(amount).times(config.annualMultiplier);

const calculateTotalDiscount = (amount) =>
  calculateYearlyDiscount(amount).times(config.sumMultiplier);

const calculateContribution = (amount) =>
  calculateYearlyDiscount(amount).div(config.outputFactor);

const calculateBenefits = (data) => {
  const amount = fixDecimalString(data);
  return {
    yearlyDiscount: formatMoney(calculateYearlyDiscount(amount)),
    totalDiscount: formatMoney(calculateTotalDiscount(amount)),
    contribution: formatMoney(calculateContribution(amount)),
  };
};

export {
  calculateTotalDiscount,
  calculateYearlyDiscount,
  calculateContribution,
  calculateBenefits,
};
